export const environment = {
	production: false,
	cacheBusterHash: '202306202',
	base_api: 'https://textandtool.com/api/',
	base_image: 'https://textandtool.com/images/',
	base_assets_image: 'https://textandtool.com',
	listLanguages: {'en': 1, 'vi': 1, 'id': 1, 'zh-cn': 1, 'th': 1},
};